import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: 'What types of construction projects do you handle?',
    answer: 'We handle a wide range of construction projects including residential buildings, commercial buildings, water tanks, retaining walls, and more. Our services also extend to design and architectural planning.',
  },
  {
    question: 'How long does a typical construction project take?',
    answer: 'Project duration varies depending on the scope and complexity. We provide detailed timelines during the initial consultation and ensure to complete projects within the agreed timeframe.',
  },
  {
    question: 'Do you provide free consultations?',
    answer: 'Yes, we offer free initial consultations to discuss your project requirements and provide preliminary guidance on how we can help.',
  },
  {
    question: 'What sets NS 24 apart from other construction companies?',
    answer: 'We combine expertise in both construction and design, ensuring comprehensive solutions. Our focus on quality, timely delivery, and customer satisfaction sets us apart.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 bg-gradient-to-r from-blue-50 to-blue-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-700">
            Find answers to common questions about our services.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`transition-transform duration-300 bg-white rounded-lg shadow-md border border-gray-300 hover:shadow-lg hover:-translate-y-1 ${
                openIndex === index ? 'border-blue-500' : ''
              }`}
            >
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span
                  className={`font-medium text-lg ${
                    openIndex === index ? 'text-blue-600' : 'text-gray-900'
                  }`}
                >
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-blue-500" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-500" />
                )}
              </button>
              {openIndex === index && (
                <div
                  className="px-6 pb-4 text-gray-700 overflow-hidden"
                  style={{
                    animation: 'fadeIn 0.3s ease-in-out',
                  }}
                >
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
